export default "__VITE_ASSET__CndbtCpg__"